import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { Observable } from 'rxjs';
import { SubscribeUbComponent } from '../subscribe-ub-base';

import { ButtonComponent, CheckboxComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

import { I18NextPipe } from 'angular-i18next';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'mbs-subscribe-ub-aws',
  templateUrl: './subscribe-ub-aws.component.html',
  styleUrls: ['./subscribe-ub-aws.component.scss'],
  imports: [AsyncPipe, ButtonComponent, CheckboxComponent, CommonModule, FormsModule, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class SubscribeUbAwsComponent extends SubscribeUbComponent {
  balance = inject<Observable<Balance>>(BALANCE_TOKEN);

  constructor() {
    super();
  }

  handleResolve(): void {
    super.handleResolve(this.acceptTerms, this.selectedStorageId, 'uba_toc_agree');
  }
}
